import React, { useState, useEffect, useRef } from "react";
import {
  FacebookShareButton,
  // FacebookMessengerShareButton,
  TwitterShareButton,
  LinkedinShareButton,
} from "react-share";
import IcomoonReact from "icomoon-react";
import * as S from "./ShareButton.sc";
import Button from "../Button/Button";
import iconSet from "../../fonts/selection.json";
import { useClickOutside } from "../../hooks/useClickOutside";
import { useSetTimeoutAlert } from "../../hooks/useSetTimeoutAlert";

const ShareButton = ({ siteUrl, allowCode }) => {
  const shareRef = useRef(null);
  const textareaRef = useRef(null);
  const [url, setUrl] = useState(siteUrl);
  const [showButtons, setShowButtons] = useState(false);
  const [showCode, setShowCode] = useState(false);
  const [activeAlert, setActiveAlert] = useSetTimeoutAlert();
  useClickOutside(shareRef, () => {
    setShowButtons(false);
  });
  useEffect(() => {
    if (!url) {
      setUrl(window.location.href);
    }
  }, []);
  const copy = () => {
    textareaRef.current.select();
    document.execCommand("copy");
    setActiveAlert(true);
  };
  return (
    <S.Container>
      <S.ButtonShare onClick={() => setShowButtons(!showButtons)}>
        <IcomoonReact
          iconSet={iconSet}
          color="#fff"
          size={16}
          icon="share"
          style={{ marginRight: 5 }}
        />
        udostępnij
      </S.ButtonShare>

      {showButtons && (
        <S.ModalContainer>
          <S.ModalContent ref={shareRef}>
            <S.Title>Udostępnij</S.Title>
            <S.IconsContainer fullWidth={allowCode ? false : true}>
              <FacebookShareButton url={url} style={{ marginRight: 5 }}>
                <S.IconContainer>
                  <IcomoonReact iconSet={iconSet} size={40} icon="share-fb" />
                  <S.IconText>FACEBOOK</S.IconText>
                </S.IconContainer>
              </FacebookShareButton>
              <TwitterShareButton url={url}>
                <S.IconContainer>
                  <IcomoonReact
                    iconSet={iconSet}
                    size={40}
                    icon="share-twitter"
                  />
                  <S.IconText>TWITTER</S.IconText>
                </S.IconContainer>
              </TwitterShareButton>
              {/* <FacebookMessengerShareButton
                url={url}
                style={{ marginRight: 5 }}
              >
                <S.IconContainer>
                  <IcomoonReact
                    iconSet={iconSet}
                    size={40}
                    icon="share-messenger"
                  />
                  <S.IconText>MESSENGER</S.IconText>
                </S.IconContainer>
              </FacebookMessengerShareButton> */}
              <LinkedinShareButton url={url} style={{ marginRight: 5 }}>
                <S.IconContainer>
                  <IcomoonReact
                    iconSet={iconSet}
                    size={40}
                    icon="share-linkedin"
                  />
                  <S.IconText>LINKEDIN</S.IconText>
                </S.IconContainer>
              </LinkedinShareButton>
              {allowCode && (
                <S.IconContainer onClick={() => setShowCode(true)}>
                  <S.IconTextLarge>{`</>`}</S.IconTextLarge>
                  <S.IconText>KOD</S.IconText>
                </S.IconContainer>
              )}
            </S.IconsContainer>
            {showCode && allowCode && (
              <S.RelativeContainer>
                <span>Treść wiadomości*</span>
                <S.Textarea
                  ref={textareaRef}
                  readOnly
                  onClick={copy}
                  value={`<iframe src="${url}"  name="agrarlex" scrolling="yes" frameborder="0" marginheight="0px" marginwidth="0px" height="315px" width="560px" allowfullscreen></iframe>`}
                ></S.Textarea>
                {activeAlert && <S.CopiedMessage>Skopiowano</S.CopiedMessage>}
              </S.RelativeContainer>
            )}

            <Button
              type="border"
              color="black"
              onClickFunction={() => setShowButtons(false)}
              customStyle={{ marginTop: 20 }}
            >
              ZAMKNIJ
            </Button>
          </S.ModalContent>
        </S.ModalContainer>
      )}
    </S.Container>
  );
};

export default ShareButton;
